import { render } from "./NuwallStock.vue?vue&type=template&id=60d3a37d&scoped=true"
import script from "./NuwallStock.vue?vue&type=script&lang=js"
export * from "./NuwallStock.vue?vue&type=script&lang=js"

import "./NuwallStock.vue?vue&type=style&index=0&id=60d3a37d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d3a37d"]])

export default __exports__